import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'

export interface SearchRequestState {
  searchRequestList?: any
  searchRequestDetail?: any
}

const initialState: SearchRequestState = {
  searchRequestList: {},
  searchRequestDetail: {},
 
}

export const searchRequestDucks = createSlice({
  name: 'searchRequest',
  initialState,
  reducers: {

    getListSearchRequest: (state: RootState, action: PayloadAction<any>) => {
      state.searchRequestList = { loading: true, queryStr: action.payload }
    },
    getListSearchRequestSuccess: (state, action: PayloadAction<any>) => {
      state.searchRequestList = { loading: false, ...action.payload }
    },
    getListSearchRequestFail: (state, action: PayloadAction<any>) => {
      state.searchRequestList = { loading: false, ...action.payload }
    },

    getDetailSearchRequest: (state: RootState, action: PayloadAction<any>) => {
      state.searchRequestDetail = { loading: true, id: action.payload }
    },
    getDetailSearchRequestSuccess: (state, action: PayloadAction<any>) => {
      state.searchRequestDetail = { loading: false, ...action.payload }
    },
    getDetailSearchRequestFail: (state, action: PayloadAction<any>) => {
      state.searchRequestDetail = { loading: false, ...action.payload }
    },

  },
})

// Action creators are generated for each case reducer function
export const {
  getListSearchRequest,
  getListSearchRequestSuccess,
  getListSearchRequestFail,
  getDetailSearchRequest,
  getDetailSearchRequestSuccess,
  getDetailSearchRequestFail,
  
} = searchRequestDucks.actions

export default searchRequestDucks.reducer
